export function getTotalCount(value) {
	return (value?.deposit?.count ?? 0) + (value?.withdraw?.count ?? 0);
}

export function getTotalAmount(value, key = 'display') {
	return (
		(value?.deposit?.[key]?.total ?? 0) -
		(value?.withdraw?.[key]?.total ?? 0)
	);
}

/**
 * @returns { { total: number, exposure: number, risk: number, account: number, currency: string } }
 */
export function getStatistics(acc, value, key = 'display', account) {
	return {
		total: (acc?.total ?? 0) + getTotalAmount(value, key),
		exposure: (acc?.exposure ?? 0) + (value?.exposure?.[key]?.total ?? 0),
		risk: (acc?.risk ?? 0) + Math.abs(value?.risk?.[key]?.total ?? 0),
		account: (acc?.account ?? 0) + (account ?? 0),
		currency:
			value?.deposit?.[key]?.currency ??
			value?.withdraw?.[key]?.currency ??
			value?.code ??
			'SEK',
	};
}
